/**
 * アップロード可能なファイルのMIMEタイプをチェックする
 * @param {File} file
 * @param {Array} acceptedMimeTypes
 * @returns {Boolean}
 */
export function isFileMimeTypeAccepted(file, acceptedMimeTypes) {
  const mimeTypeToExtensions = {
    "image/png": [".png"],
    "image/gif": [".gif"],
    "image/jpeg": [".jpg", ".jpeg"],
    "application/pdf": [".pdf"],
  };

  return acceptedMimeTypes.some((type) => {
    // MIMEタイプに対応する拡張子をチェック
    const extensions = mimeTypeToExtensions[type];
    if (
      extensions &&
      extensions.some((extension) =>
        file.name.toLowerCase().endsWith(extension),
      )
    ) {
      return true;
    }

    // MIMEタイプをチェック
    // blob.type は信頼性が低そうだけど、一致してるなら問題ない。
    return file.type === type;
  });
}
